import { createFileRoute } from "@tanstack/react-router";
import { AccessDenied } from "@/components/nancy/access-denied";
import { NancyPage } from "@/routes/_authenticated/nancy/-components/nancy-page";
import { useNancyFacility } from "@/routes/_authenticated/nancy/-lib/use-nancy-facility";

// No loader: the building is the header switcher's choice, known only once facilities load.
export const Route = createFileRoute("/_authenticated/ws/nancy/_gate/orders/$orderId")({
  head: () => ({
    meta: [
      { title: "Order | Nancy | People AI" },
      { name: "description", content: "One order, one conversation with Nancy." },
    ],
  }),
  component: NancyOrder,
});

function NancyOrder() {
  const { orderId } = Route.useParams();
  const { facilityId, can } = useNancyFacility();
  if (!can("read")) {
    return (
      <AccessDenied
        title="No access to Nancy"
        description="You do not have access to Nancy's orders in this community."
      />
    );
  }
  // A new order or a new community is a new page: nothing of the last one's stream survives.
  return <NancyPage key={`${facilityId}:${orderId}`} threadId={orderId} />;
}
